<template>
  <span
    :class="'tooltip tooltip-' + position"
    v-pure-html="text">
  </span>
</template>

<script>
export default {
  name: 'tooltip',
  props: {
    'text': {
      default: ''
    },
    'position': {
      default: 'top'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.tooltip {
  background: $color-dark;
  border-radius: $border-radius-small;
  color: $color-light;
  display: block;
  font-size: 1.4rem;
  font-weight: 400;
  height: 2.6rem;
  left: 36px;
  opacity: 0;
  padding: .5rem 1rem 0 1rem;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: all .25s ease-out;
  white-space: nowrap;
  width: auto;
  z-index: 1;

  &:after {
    border: .5rem solid $color-dark;
    border-left-color: transparent;
    border-top-color: transparent;
    border-bottom-color: transparent;
    bottom: -1rem;
    content: "";
    height: 1rem;
    left: -1rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 1rem;
  }

  &.tooltip-top {
    left: 50%;
    top: -24px;
    transform: translateX(-50%);

    &:after {
      border: .5rem solid $color-dark;
      border-left-color: transparent;
      border-right-color: transparent;
      border-bottom-color: transparent;
      bottom: -1rem;
      content: "";
      height: 1rem;
      left: 50%;
      position: absolute;
      top: auto;
      transform: translateX(-50%);
      width: 1rem;
    }
  }

  &.tooltip-bottom {
    left: 50%;
    top: 100px;
    transform: translateX(-50%);

    &:after {
      border: .5rem solid $color-dark;
      border-left-color: transparent;
      border-right-color: transparent;
      border-top-color: transparent;
      bottom: auto;
      content: "";
      height: 1rem;
      left: 50%;
      position: absolute;
      top: -1rem;
      transform: translateX(-50%);
      width: 1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Tooltip.vue